// extracted by mini-css-extract-plugin
export default {"container":"LoginButtons_container__NsLNi"};